import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { listsQueryKeys } from "app/pages/sales-intelligence/modules/lists/query/key-factory/factory";
import type { TagColumnValueResponse } from "app/pages/sales-intelligence/modules/lists/types/columns";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

const selectData = (data: readonly TagColumnValueResponse[]): readonly TagColumnValueResponse[] => {
    const defaultTags = data.slice(0, 3).sort((a, b) => a.Id.localeCompare(b.Id));
    const rest = data.slice(3);

    return [...defaultTags, ...rest];
};

export const useTagsQuery = (listId: string): UseQueryResult<readonly TagColumnValueResponse[]> => {
    return useQuery({
        enabled: !!listId,
        queryKey: listsQueryKeys.getTags(listId),
        queryFn: ({ signal }) => {
            return salesApiService.listColumns.fetchTags(listId, { cancellation: signal });
        },
        select: selectData,
    });
};
